import React, { FC } from 'react';

import { EmptyState } from 'app/design-system/components/EmptyState/EmptyState';
import { FavoritesIcon } from 'app/design-system/components/MulticolorIcons';
import { Widget } from 'app/design-system/components/Widget/Widget';
import { useTranslation } from 'app/lang';

import dictionary from './FavoritesEmptyState.dictionary.json';

import styles from './FavoritesEmptyState.module.scss';

const FavoritesEmptyState: FC = () => {
  const { t } = useTranslation();

  return (
    <Widget className={styles.container}
            contentClassName={styles.content}>
      <EmptyState image={<FavoritesIcon />}
                  title={t(dictionary.title)}
                  description={t(dictionary.text)} />
    </Widget>
  );
};

export default FavoritesEmptyState;
